import { Check, ArrowRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Reveal } from "./Reveal";

const Banner = ({ id, title, points, cta, img }) => (
  <div data-testid={`banner-${id}`} className="group relative isolate flex min-h-[340px] overflow-hidden rounded-3xl border border-white/10 bg-[#0B1224] p-8 sm:p-10">
    <img src={img} alt="" className="absolute inset-y-0 right-0 -z-10 h-full w-[75%] object-cover transition-transform duration-700 group-hover:scale-105" />
    <div className="absolute inset-0 -z-10 bg-gradient-to-r from-[#0B1224] via-[#0B1224]/85 to-transparent" />
    <div className="absolute -right-10 top-0 -z-10 h-full w-1/2 skew-x-[-18deg] bg-gradient-to-r from-transparent via-[#2F7BFF]/10 to-transparent" />
    <div className="relative flex max-w-sm flex-col">
      <h2 className="font-display text-3xl font-bold text-white sm:text-4xl">{title}</h2>
      <ul className="mt-5 space-y-2.5">
        {points.map((p) => (
          <li key={p} className="flex items-start gap-3 text-[15px] text-slate-300">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#2F7BFF]" strokeWidth={3} />{p}
          </li>
        ))}
      </ul>
      <a href="/#contact" data-testid={`banner-${id}-cta`} className="mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-[#2F7BFF] px-6 py-3 text-sm font-bold text-white shadow-[0_10px_30px_-10px_rgba(47,123,255,.9)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#1F63E0]">
        {cta} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </a>
    </div>
  </div>
);

export const Banners = () => {
  const { t } = useLang();
  const h = t.hero;
  return (
    <section id="banners" data-testid="banners-section" className="py-16 lg:py-20">
      <Reveal className="mx-auto grid max-w-7xl gap-6 px-5 lg:grid-cols-2 lg:px-8">
        <Banner id="buy" title={h.buyTitle} points={h.buyPoints} cta={h.buyCta} img="/img/buy.jpg" />
        <Banner id="partner" title={h.sellTitle} points={h.sellPoints} cta={h.sellCta} img="/img/partner.jpg" />
      </Reveal>
    </section>
  );
};
